import React from 'react'
import {
  Box,
  Button,
  IconButton,
  TextField,
  Tooltip,
  Typography,
  makeStyles,
} from '@material-ui/core'
import {
  AddCircleOutline,
  DeleteOutline,
  VisibilityOutlined,
  VisibilityOffOutlined,
} from '@material-ui/icons'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  sectionBlock: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    padding: theme.spacing(1.5),
    backgroundColor: theme.palette.grey[50],
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.grey[200]}`,
    transition: 'opacity 0.2s',
  },
  sectionBlockHidden: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    padding: theme.spacing(1.5),
    backgroundColor: theme.palette.grey[100],
    borderRadius: theme.shape.borderRadius,
    border: `1px dashed ${theme.palette.grey[300]}`,
    opacity: 0.5,
    transition: 'opacity 0.2s',
  },
  sectionFields: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    flex: 1,
  },
  sectionActions: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 2,
    marginTop: theme.spacing(0.5),
  },
  addButton: {
    alignSelf: 'flex-start',
  },
  hiddenBadge: {
    fontSize: 10,
    fontWeight: 600,
    color: theme.palette.warning.main,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
}))

const TermsEditor = ({ data, onChange }) => {
  const classes = useStyles()
  const sections = data.sections || []

  const handleSectionChange = (index, field, value) => {
    const updated = sections.map((section, i) =>
      i === index ? { ...section, [field]: value } : section
    )
    onChange('sections', updated)
  }

  const handleToggleHidden = (index) => {
    const updated = sections.map((section, i) =>
      i === index ? { ...section, hidden: !section.hidden } : section
    )
    onChange('sections', updated)
  }

  const handleAddSection = () => {
    onChange('sections', [...sections, { title: '', content: '', hidden: false }])
  }

  const handleRemoveSection = (index) => {
    onChange(
      'sections',
      sections.filter((_, i) => i !== index)
    )
  }

  return (
    <Box className={classes.root}>
      <Typography variant="subtitle2">Terms & Conditions Sections</Typography>

      {sections.map((section, index) => (
        <Box
          key={index}
          className={section.hidden ? classes.sectionBlockHidden : classes.sectionBlock}
        >
          <Box className={classes.sectionFields}>
            <TextField
              label="Section Title"
              value={section.title || ''}
              onChange={(e) =>
                handleSectionChange(index, 'title', e.target.value)
              }
              size="small"
              variant="outlined"
              fullWidth
            />
            <TextField
              label="Content"
              value={section.content || ''}
              onChange={(e) =>
                handleSectionChange(index, 'content', e.target.value)
              }
              size="small"
              variant="outlined"
              fullWidth
              multiline
              rows={3}
            />
            {section.hidden && (
              <Typography className={classes.hiddenBadge}>Hidden from proposal</Typography>
            )}
          </Box>
          <Box className={classes.sectionActions}>
            <Tooltip title={section.hidden ? 'Show in proposal' : 'Hide from proposal'}>
              <IconButton
                size="small"
                onClick={() => handleToggleHidden(index)}
                color={section.hidden ? 'default' : 'primary'}
              >
                {section.hidden ? <VisibilityOffOutlined fontSize="small" /> : <VisibilityOutlined fontSize="small" />}
              </IconButton>
            </Tooltip>
            <Tooltip title="Remove permanently">
              <IconButton
                size="small"
                onClick={() => handleRemoveSection(index)}
                style={{ color: '#ccc' }}
              >
                <DeleteOutline style={{ fontSize: 16 }} />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      ))}

      <Button
        startIcon={<AddCircleOutline />}
        onClick={handleAddSection}
        size="small"
        color="primary"
        className={classes.addButton}
      >
        Add Section
      </Button>
    </Box>
  )
}

export default TermsEditor
